/**
 * home
 */
 import banner_1 from '../../assets/img/aboveTheFold/banner_1.png';
 import banner_2 from '../../assets/img/aboveTheFold/banner_2.png';

import servicesSwiperImgBg from '../../assets/img/servicesSwiper/img_bg.png';
import servicesSwiperImg1 from '../../assets/img/servicesSwiper/img_1.png';
import servicesSwiperImg2 from '../../assets/img/servicesSwiper/img_2.png';
import servicesSwiperImg3 from '../../assets/img/servicesSwiper/img_3.png';

import ourAdvantagesBgImg01 from '../../assets/img/ourAdvantages/img_01_3x.png';
import ourAdvantagesBgImg02 from '../../assets/img/ourAdvantages/img_02_3x.png';
import ourAdvantagesBgImg03 from '../../assets/img/ourAdvantages/img_03_3x.png';

import union1 from '../../assets/img/icons/union_1.svg';
import union2 from '../../assets/img/icons/union_2.svg';
import union3 from '../../assets/img/icons/union_3.svg';
import union4 from '../../assets/img/icons/union_4.svg';
import union5 from '../../assets/img/icons/union_5.svg';
import union6 from '../../assets/img/icons/union_6.svg';

import casesImg1 from '../../assets/img/cases/img_1.jpg';
import casesImg2 from '../../assets/img/cases/img_2.jpg';
import casesImg3 from '../../assets/img/cases/img_3.jpg';
import casesImg4 from '../../assets/img/cases/img_4.jpg';
import casesImg5 from '../../assets/img/cases/img_5.jpg';
import casesImg6 from '../../assets/img/cases/img_6.jpg';
import casesImg7 from '../../assets/img/cases/img_7.jpg';
import casesImg8 from '../../assets/img/cases/img_8.jpg';
import casesImg9 from '../../assets/img/cases/img_9.jpg';
import casesImg10 from '../../assets/img/cases/img_10.jpg';
import casesImg11 from '../../assets/img/cases/img_11.jpg';

// global config file start
const {
  websiteRecord, // 网站备案/版权
  companyName, // 公司名字
  abbreviation, // 简称->中文
  companyAddress,  // 公司地址->中文
  contactInformation, // 联系方式
  mapInfo, // 地图位置
} = window.globalConfig;
// global config file end

const zhCN = {
  'lang': 'English',
  home: {
    aboveTheFoldList: [
      {
        id: 1001,
        title: 'Serve every customer with heart and soul',
        desc: 'Event Planning / Advertising Decoration / Event Catering / Video Production',
        img: banner_1,
      },
      {
        id: 1002,
        title: 'Focus on quality event exhibition planning',
        desc: 'Event Planning / Advertising Decoration / Event Catering / Video Production',
        img: banner_2,
      }
    ],
    entertainment:{
      leftContent: {
        title: companyName.fullNameEN,
        subTitle: `We provide all kinds of event planning, full branding and film production services for enterprises.`,
        desc: 'SINCE 2019',
        list: [
          {
            id: 1001,
            desc: `${abbreviation.abbreviationEN} has a creative team with both strategic concepts and practical experience, an efficient and flexible execution team, and a standardized and mature project control mechanism, providing a full range of services from planning, design to execution, and striving to bring our customers the most professional, cutting-edge and effective event services.`,
          },
          {
            id: 1002,
            desc: 'Over the years we have designed various types of events for many small and medium-sized enterprises throughout the year, and have undertaken many event planning and operation management, so that each client has received superb quality service and friendly comments from several clients.',
          },
          {
            id: 1003,
            desc: 'In the future, we look forward to creating more brilliance together with you',
          },
        ] 
      },
      rightContent: {
        textList: [
          {
            id: 1001,
            title: 'Industry experience',
            number: '4',
            desc: 'years',
          },
          {
            id: 1002,
            title: 'Full follow-up',
            number: '1V1',
            desc: '',
          },
          {
            id: 1003,
            title: 'Heartfelt service',
            number: '100',
            desc: '%',
          },
        ] 
      }
    },
    servicesSwiperList: [
      {
        id: 1001,
        bg: servicesSwiperImgBg,
        img: servicesSwiperImg1,
        coloValue: ['#0A3DBE', '#FAFAFE', '#0A3DBE'],
        headTop: {
          title: 'Services',
          subTitle: 'More efficient, less hassle, more professional',
        },
        title: 'Event Planning',
        subTitle: 'Professional team, professional service',
        descList: [
          {
            id: 1001,
            text: 'We provide companies with planning solutions for both external marketing and internal administrative activities.'
          },
          {
            id: 1002,
            text: `We uphold the "creative winning" and "refinement of operation" concept of event planning, creative thinking to create a different activity program, through the differentiated works to highlight the customer's brand personality.`,
          },
        ],
        strongLisg: [
          {
            id: 1001,
            text: 'Birthday Party / Christmas / Conference Forum / Reception Dinner',
          },
          {
            id: 1002,
            text: 'Annual Meeting Celebration / Signing Ceremony / Construction Opening',
          }
        ],
        textList: [
          {
            id: 1001,
            title: 'Creative planning: ',
            text: 'integrate corporate brand characteristics, tailor-made activity plans, screening and recommending the best venues.',
          },
          {
            id: 1002,
            title: 'Choreography design: ',
            text: 'on-site survey of the site, combined with the activity program for reasonable layout planning.',
          },
          {
            id: 1003,
            title: 'Performing arts resources: ',
            text: 'provide various types of performing arts resources such as dancing, singing, magic, skits, bilingual hosts, etc.',
          },
          {
            id: 1004,
            title: 'Venue layout:',
            text: 'professional technical construction team, providing satisfactory services from equipment installation, use, maintenance to withdrawal of the whole process.',
          },
          {
            id: 1005,
            title: 'On-site management: ',
            text: 'the whole activity site control, meticulous and rigorous rehearsal, a full range of contingency plans to ensure that the activity is foolproof.',
          },
          {
            id: 1006,
            title: 'Video production: ',
            text: 'based on corporate culture, around the theme of the event, for the event site shooting, promotional film production.',
          },
        ]
      },
      {
        id: 1002,
        bg: servicesSwiperImgBg,
        img: servicesSwiperImg2,
        coloValue: ['#E24C38', '#FAFAFE', '#E24C38'],
        headTop: {
          title: 'Services',
          subTitle: 'More efficient, less hassle, more professional',
        },
        title: 'Event Catering',
        subTitle: 'Global cuisine, taste the world',
        descList: [
          {
            id: 1001,
            text: `With the health and safety of our customers as our top priority, we provide professional Chinese and Western cuisine, exquisite tea party snacks, Hong Kong-style snacks, conference snacks, various cocktail parties, opening tea parties and decoration services to add more style to your event.`,
          },
        ],
        strongLisg: null,
        textList: [
          {
            id: 1001,
            title: 'Dedicated follow-up: ',
            text: 'dedicated staff to discuss your catering and event arrangement needs, clear communication and seamless collaboration.',
          },
          {
            id: 1002,
            title: 'Innovative and classic: ',
            text: 'diversified Chinese and Western cuisines and creative Fusion meals, offering endless choices.',
          },
          {
            id: 1003,
            title: 'Tailor-made:',
            text: `professional chef cuisine according to customer's personal preference, taste or corporate culture, event venue environment, catering budget and food type requirements, etc., tailor-made special meals.`,
          },
          {
            id: 1004,
            title: 'Both inside and outside: ',
            text: 'comprehensive arrival equipment and sufficient service staff to meet the different needs of indoor and outdoor event venues.',
          },
          {
            id: 1005,
            title: 'Value-added services: ',
            text: 'we can provide fun ideas for the event site to increase the joyful atmosphere: we can also provide venue decoration, on-site photography and video shooting.',
          },
        ]
      },
      {
        id: 1003,
        bg: servicesSwiperImgBg,
        img: servicesSwiperImg3,
        coloValue: ['#7C31C7', '#FAFAFE', '#7C31C7'],
        headTop: {
          title: 'Services',
          subTitle: 'More efficient, less hassle, more professional',
        },
        title: 'Film Production',
        subTitle: 'Better understanding of business & marketing',
        descList: [
          {
            id: 1001,
            text: `We have provided marketing video services for hundreds of companies, and we understand what companies want.`
          },
          {
            id: 1002,
            text: `We focus on creative planning, shooting and post-production of high-end events, abide by the international standard of professional video production mode of operation, focus on the combination of commercial timeliness and visual artistry, to provide valuable video services for enterprises.`
          },
        ],
        strongLisg: [
          {
            id: 1001,
            text: 'Product Features / Corporate Promotion / Film Advertising',
          },
          {
            id: 1002,
            text: 'Media Placement / Animation Production / Event Recording',
          }
        ],
        textList: [
          {
            id: 1001,
            title: 'Effect guarantee: ',
            text: `The whole process execution team of pre-planning, mid-term shooting, post-production editing, design and special effects production.`,
          },
          {
            id: 1002,
            title: 'Experienced: ',
            text: `accumulated rich experience in project operation and management to ensure that each project lands perfectly.`,
          },
          {
            id: 1003,
            title: 'Filming equipment: ',
            text: `professional filming equipment to make the film stand out among peers.`,
          },
          {
            id: 1004,
            title: 'Service commitment:',
            text: `1V1 project manager follows the project throughout the whole process and provides free multi-length version editing.`
          },
        ]
      },
    ],
    ourAdvantages: {
      title: 'Our Advantages',
      subTitle: 'Leading the peers, thinking what you think',
      list: [
        {
          id: '01',
          img: ourAdvantagesBgImg01,
          title: 'Resources',
          desc: 'Provide customers with a variety of hotels, special venues, acting and performing talents, and various meal options.',
        },
        {
          id: '02',
          img: ourAdvantagesBgImg02,
          title: 'Equipments',
          desc: 'Equipped with professional cameras, drones and other mainstream photography equipment.',
        },
        {
          id: '03',
          img: ourAdvantagesBgImg03,
          title: 'Team',
          desc: 'Core members are experienced, providing you with satisfactory and assured execution guarantee.',
        }
      ],
      flowNums: {
        title: 'Service Flow',
        subTitle: 'Our services are standardized and detailed',
        list: [
          {
            num: '01',
            icon: union1,
            name: 'Demand negotiation',
          },
          {
            num: '02',
            icon: union2,
            name: 'Site survey',
          },
          {
            num: '03',
            icon: union3,
            name: 'Customized solutions',
          },
          {
            num: '04',
            icon: union4,
            name: 'Site-setting',
          },
          {
            num: '05',
            icon: union5,
            name: 'Landing execution',
          },
          {
            num: '06',
            icon: union6,
            name: 'Project summary',
          },
        ]
      },
    },
    casesInfo: {
      title: 'Cases',
      subTitle: 'Create value for customers',
      desc: 'Annual Party /Festival / Event Advertising Layout / Opening Ceremony / Cocktail Party Planning',
      list: [
        { id: 1001, img: casesImg1 },
        { id: 1002, img: casesImg2 },
        { id: 1003, img: casesImg3 },
        { id: 1004, img: casesImg4 },
        { id: 1005, img: casesImg5 },
        { id: 1006, img: casesImg6 },
        { id: 1007, img: casesImg7 },
        { id: 1008, img: casesImg8 },
        { id: 1009, img: casesImg9 },
        { id: 1010, img: casesImg10 },
        { id: 1011, img: casesImg11 },
      ]
    },
    contacts: {
      title: 'Contact',
      subTitle: `Call now we're ready to serve you`,
      mapName: mapInfo.nameEN,
      mapAddress: mapInfo.map,
      list: [
        {
          id: 1001,
          name: 'Working Time',
          desc: `Mon. - Sat. 9:00~18:00`
        },
        {
          id: 1002,
          name: 'Address',
          desc: companyAddress.addressEN
        },
        {
          id: 1003,
          name: 'Tel',
          desc: contactInformation.tel
        },
        {
          id: 1004,
          name: 'E-mail',
          desc: contactInformation.mail
        },
      ]
    },
    website: websiteRecord.copyrightEN,
  },
 
};
export default zhCN;
